
import React, { useEffect ,useState} from 'react';
import '../Assets/Css/intro.css';
import { Helmet } from 'react-helmet';
import { Container, Row, Col } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import { BASE_URL } from '../BaseURL';
import { toast ,Toaster } from 'react-hot-toast';

// Import your only image
import Gallery1 from '../Assets/Image/hiranad-gallery1.png';


export default function IntroStrategySessions() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
    AOS.refresh();
  }, []);

   const [uploadedImages, setUploadedImages] = useState([]);
   const [videos, setVideos] = useState([]);

const fetchImages = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/gallery/getImages`);
      if (res.data.success) setUploadedImages(res.data.data);
    } catch {
      toast.error('Failed to fetch images');
    }
  };

  const fetchVideos = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/gallery/getVideos`);
      if (res.data.success) setVideos(res.data.data);
    } catch {
      toast.error('Failed to fetch videos');
    }
  };

  useEffect(() => {
    fetchImages();
    fetchVideos();
  }, []);


  const images = [Gallery1];
  // const videos = ['7pth6Pq5cRE', '-QYXN5pyqT4?si=90mX4NcCZ-FTcARc']
  return (
    <div>
      <Helmet>
        <title>Our Gallery | Hiranand Agri Solutions Pvt. Ltd.</title>
      </Helmet>

      {/* Banner */}
      <div className="bannereintro-section d-flex align-items-center justify-content-center">
        <div className="bannereintro-overlay text-center" data-aos="zoom-in">
          <h2 className="banner1-title">HASPL Gallery</h2>
          <p className="banner1-subtitle" data-aos="zoom-in" data-aos-delay="200">
            Discover our journey through captured moments and experiences that define Hiranand Agri Solutions Pvt. Ltd.
          </p>
        </div>
      </div>

      {/* Gallery Section */}
      <section className="py-5 gallery-section" style={{ backgroundColor: '#f9f9f9' }}>
        <Container>
          <h3 className="text-center mb-4 fw-bold" data-aos="fade-down">
            Explore Our <span style={{ color: '#16343E' }}>Moments</span>
          </h3>
          <Row className="d-flex justify-content-center">
           

             {uploadedImages.map((img, index) => (
            <Col key={index} xs={6} sm={4} md={3} className="mb-3 position-relative">
              <img src={`${BASE_URL}${img.fileUrl}`} alt={`Gallery ${index}`} className="gallery-img" />
             
            </Col>
          ))}
          </Row>
        </Container>
      </section>

      {/* YouTube Video Section */}
      <section className="py-5 video-section" style={{ backgroundColor: '#fff' }}>
        <Container>
          <h3 className="text-center mb-4 fw-bold" data-aos="fade-down">
            Watch Our <span style={{ color: '#16343E' }}>Live Moments</span>
          </h3>
          <Row className="justify-content-center">
           

{videos.map((vid, index) => (
            <Col key={index} xs={12} sm={6} md={4} className="mb-4 position-relative">
              <div className="ratio ratio-16x9">
                <iframe src={vid.fileUrl} title={`Video-${index}`} allowFullScreen />
              </div>
              
            </Col>
          ))}

          </Row>
        </Container>
      </section>

    </div>
  );
}
